import { render } from "./AssistantTeacherSubmission.vue?vue&type=template&id=55c838df&scoped=true"
import script from "./AssistantTeacherSubmission.vue?vue&type=script&lang=js"
export * from "./AssistantTeacherSubmission.vue?vue&type=script&lang=js"

import "./AssistantTeacherSubmission.vue?vue&type=style&index=0&id=55c838df&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c838df"]])

export default __exports__